<template>
 <div>
  <b-navbar class="white" fixed="top" type="light" toggleable>
    <b-navbar-toggle target="nav_dropdown_collapse"></b-navbar-toggle>
    <b-collapse is-nav id="nav_dropdown_collapse">
      <b-navbar-nav>
        <b-nav-item><router-link class="navbar-link" to="/">home</router-link></b-nav-item>
        <b-nav-item><router-link class="navbar-link" to="/about">about</router-link></b-nav-item>
        <!-- <b-nav-item href="mailto:daniel.ruginets@gmail.com"><a class="navbar-link" href="mailto:daniel.ruginets@gmail.com" target="_top">daniel.ruginets@gmail.com</a> </b-nav-item> -->
        <b-nav-item target="_blank" href="./../../static/assets/DanielRuginets_Resume.pdf"><a class="navbar-link">resume.pdf</a></b-nav-item>
                              <!-- <b-nav-item-dropdown class="navbar-link2" text="projects">
             <b-dropdown-item class="nav-item"><router-link class="navbar-link" to="/glide">Glide</router-link></b-dropdown-item>
             <b-dropdown-item class="nav-item"><router-link class="navbar-link" to="/snapsuite">SnapSuite</router-link></b-dropdown-item>
             <b-dropdown-item class="nav-item"><router-link class="navbar-link" to="/fashionforchange">Fashion for Change</router-link></b-dropdown-item>
             <b-dropdown-item class="nav-item"><router-link class="navbar-link" to="/veganambition">The Vegan Ambition</router-link></b-dropdown-item>
        </b-nav-item-dropdown> -->
                <!-- <b-nav-item >  <div>
    <div v-if="loggedIn"><a class="navbar-link" @click="signOut">sign out</a></div>
    <div v-else><a class="navbar-link" @click="signOut">login</a></div>
  </div></b-nav-item> -->
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</div>

</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/auth'
export default {
  name: 'navbar',
  mounted () {
    this.setupFirebase()
  },
  methods: {
    setupFirebase () {
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          // User is signed in.
          console.log('signed in')
          this.loggedIn = true
        } else {
          // No user is signed in.
          this.loggedIn = false
          console.log('signed out', this.loggedIn)
        }
      })
    },
    signOut () {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({ name: 'login' })
        })
    }
  },
  data () {
    return {
      loggedIn: false
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Righteous');

.nav-link{
  color:#000000 !important;
}
.white{
  background-color: #ffffff;
}
.navbar-link {
  color: #000000;
  text-decoration: none;
  text-decoration-color: #187BC2;
  -webkit-transition: color 0.7s; /* For Safari 3.0 to 6.0 */
  transition: color 0.7s; /* For modern browsers */
      transition: background-size .4s ease;
  background: linear-gradient(to bottom, transparent 62%, #187BC2 0) center center/0% 75% no-repeat;
  padding: 0 6px 2px 6px;
    font-weight: 600;
}
.navbar-link:hover {
  background-size: 100% 100%;
  color: #000000;
}
.nav-item:hover {
  background-color: white;
  cursor: default;
}
.navbar-link2{
  border: none;
    color: #000000;
  text-decoration: none;
  text-decoration-color: #187BC2;
  -webkit-transition: color 0.7s; /* For Safari 3.0 to 6.0 */
  transition: color 0.7s; /* For modern browsers */
      transition: background-size .4s ease;
  background: linear-gradient(to bottom, transparent 62%, #187BC2 0) center center/0% 75% no-repeat;
  padding: 0 6px 2px 3px;
    font-weight: 600;
}

</style>



// WEBPACK FOOTER //
// src/components/navbar.vue